import { Button, IconButton } from "rsuite";
import { useEffect, useState } from "react";

import authService from "../../services/auth.service";
import DetectPlatformService from "../../services/detectPlatform";

const Buttons = function (props) {
  const { buttons } = props;
  const [platform, setPlatform] = useState("unknown");
  const user = authService.getCurrentUser()?.user;
  const isForeign = user?.is_foreign;

  useEffect(() => {
    const platform = DetectPlatformService;
    setPlatform(platform);
  }, []);

  return buttons.map((button, key) => {
    let Elm = Button;
    if (isForeign && button.id === "btn-app-bottom-sheet") {
      return null;
    }

    switch (button.type) {
      case "icon_button":
        Elm = IconButton;
        break;
      default:
        break;
    }

    let styles = button.styles;

    if (
      styles &&
      styles.backgroundImage &&
      !styles.backgroundImage.includes("url")
    ) {
      styles.backgroundImage = `url(${styles.backgroundImage})`;
    }

    return (
      <Elm
        key={key}
        style={styles}
        className={
          button.custom_classes ? button.custom_classes.join(" ") : null
        }
        onClick={(e) => onClick(button)}
        startIcon={
          button.icon && button.icon.position === "start"
            ? getIcon(button.icon)
            : null
        }
        endIcon={
          button.icon && button.icon.position === "end"
            ? getIcon(button.icon)
            : null
        }
        icon={
          button.icon && button.icon.position === "center"
            ? getIcon(button.icon)
            : null
        }
        circle={button.attributes && button.attributes.circle}
      >
        {button.title ? button.title : ""}
        {button.image && button.image.original ? (
          <img
            src={button.image.original}
            style={button.image.styles ? button.image.styles : {}}
            alt=""
          />
        ) : (
          ""
        )}
      </Elm>
    );
  });

  function getIcon(icon) {
    if (icon.type === "image") {
      return <img src={icon.value} alt="" />;
    }
  }

  function onClick(button) {
    if (button.data) {
      if (
        platform === "android" &&
        button.data.mobile &&
        window.innerWidth <= 768
      ) {
        onClickAction(button, button.data.mobile);
      } else if (platform === "ios" && button.data.mobile?.ios) {
        onClickAction(button, button.data.mobile.ios);
      } else {
        if (button.data.desktop && window.innerWidth > 768) {
          onClickAction(button, button.data.desktop);
        } else if (button.data.type) {
          onClickAction(button, button.data);
        }
      }
    }
  }

  function onClickAction(button, data) {
    switch (data.type) {
      case "bottom_sheet":
        data.opened = true;
        props.bottomSheetHandler({ ...data, id: button.id });
        break;

      case "intend":
        if (data.value) {
          window.location.href = data.value;
        }
        break;
      default:
        break;
    }
  }
};

export default Buttons;
